import React from 'react';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';
import MainPage from '../../../composents/MainPage';

const title = 'Cities';
const headers = {
	icon: 'feather icon-command',
	title: title,
	description: 'track and manage all cities information',
};

export default function HyrdrodripPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{
						label: 'City name',
						field: 'name',
					},
					{
						label: 'Code 1',
						field: 'code_1',
					},
					{
						label: 'Code 2',
						field: 'code_2',
					},
					{
						label: 'Country name',
						field: 'country',
						render: ['name'],
					},
					{
						label: 'Description',
						field: 'description',
					},
				]}
				resource={resources.city}
				title={title}
				link="/hydrodrip/cities"
			/>
		</MainPage>
	);
}
